import { Close, MenuIcon } from "assets/svg";

import { useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useEventStore } from "store";

export default function TopBar({ onClose }: { onClose?: () => void }) {
  const { event, theme } = useEventStore();
  const navigate = useNavigate();
  const location = useLocation();

  const onclick = () => {
    if (location.pathname === "/feed/v2") {
      navigate("/feed/v2/menu");
      return;
    }
    if (onClose) {
      onClose();
      return;
    }
    navigate("/feed/v2");
  };

  const titleFontClass = useMemo(() => {
    const templateName = event?.customization?.template.name;
    const titleFontFamily = event?.customization?.template.titleFontFamily;
    const isBirthdayEvent = templateName?.includes("birthday");

    if (
      titleFontFamily !== "default" &&
      titleFontFamily !== "font-high-spirited"
    ) {
      return titleFontFamily + " text-xl";
    }

    if (titleFontFamily === "font-high-spirited") {
      return titleFontFamily + " text-3xl pb-1";
    }

    if (templateName === "wedding-white" && titleFontFamily === "default") {
      return "font-playfair-display text-xl";
    }

    if (templateName === "wedding-rose" && titleFontFamily === "default") {
      return "font-high-spirited text-3xl pb-1";
    }

    if (
      event?.customization?.template.name === "birthday-blue" &&
      titleFontFamily === "default"
    ) {
      return "font-playfair-display text-xl";
    }

    if (isBirthdayEvent && titleFontFamily === "default") {
      return "font-style-script text-xl";
    }

    return "font-century-gothic-bold text-xl";
  }, [
    event?.customization?.template.name,
    event?.customization?.template.titleFontFamily,
  ]);

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 h-12 ${
        theme.name === "rose" ? "bg-primary-rose" : "bg-black"
      } flex items-center px-4 shadow-lg border-b border-black/10 backdrop-blur-sm`}
    >
      <div className="absolute inset-x-0 flex justify-center items-center">
        <span
          className={`truncate text-center max-w-[calc(100vw-4rem)] px-4  ${titleFontClass}  text-white drop-shadow-sm`}
        >
          {event?.customization?.template.titleOneText}

          {event?.customization?.template.name === "wedding-white"
            ? ` & ${event?.customization?.template.titleTwoText}`
            : null}
        </span>
      </div>

      <button
        className="ml-auto px-0 z-20 hover:bg-white/10 rounded-full p-1 transition-colors duration-200"
        onClick={onclick}
      >
        {location.pathname === "/feed/v2" ? (
          <MenuIcon width={32} height={32} color={"none"} outline={"white"} />
        ) : (
          <Close width={32} height={32} color={"none"} outline={"white"} />
        )}
      </button>
    </div>
  );
}
